import React, { useContext, useRef, useState } from "react";
import { VendorContext } from "../../../../../context/vendor/VendorContext";
import { useMsal } from "@azure/msal-react";
import { ButtonUpload, CssTextField } from "../../style";
import { Button, Container, Column, ColumnButtons, Tittle } from "../style";
import { useTranslation } from "react-i18next";
import { OneColumn } from "./style";
import { UploadFile } from "@mui/icons-material";

const Step5 = () => {
  const { t } = useTranslation();
  const {
    steps,
    activeStep,
    vendorInformation,
    vendDocumentation,
    vendFlowEnrollment,
    setActiveStep,
    getBase64,
    getCompanyInformation,
    sendVendDocumentation,
    sendVendFlowEnrollment,
    sendVendorInformation,
    sendVendorInformationStatement,
  } = useContext(VendorContext);
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  const handleInformation = (event) => {
    event.preventDefault();
    vendorInformation[event.target.name] = event.target.value;
    sendVendorInformation(vendorInformation);
  };
  const submitForm = async (e) => {
    e.preventDefault();
    vendorInformation["statemenT_DATE"] =
      document.getElementById("statemenT_DATE").value;
    await sendVendorInformation(vendorInformation);
    const dataPdf = {
      guiD_VEND: vendorInformation.guiD_PRIMARY_CONTACT,
      tittle: t(steps[4]),
      body: t("declarationDescription"),
      labeL_PLACE: t("placeDate"),
      labeL_DATE: t("date"),
      labeL_FULLNAME: t("fullName"),
      labeL_POSITION: t("positionCompany"),
    };
    await sendVendorInformationStatement(dataPdf);

    if (vendFlowEnrollment.lasT_STEP === activeStep) {
      vendFlowEnrollment["lasT_STEP"] = vendFlowEnrollment.lasT_STEP + 1;
      await Promise.all([sendVendFlowEnrollment(vendFlowEnrollment)]);
    }
    handleNext();
  };
  console.log(steps);
  return (
    <>
      <form
        onSubmit={(e) => {
          submitForm(e);
        }}
      >
        <Tittle>{t(steps[4])}</Tittle>
        <br />
        <br />
        <Container>
          <OneColumn>
            <h5>{t("declarationDescription")}</h5>
          </OneColumn>
        </Container>
        <Container>
          <Column>
            <CssTextField
              value={vendorInformation.statemenT_PLACE}
              type="text"
              required
              fullWidth
              name="statemenT_PLACE"
              id="statemenT_PLACE"
              label={t("placeDate")}
              onChange={(e) => handleInformation(e)}
            />
          </Column>
          <Column>
            <CssTextField
              value={new Date().toISOString().slice(0, 10).toString()}
              type="date"
              disabled
              required
              fullWidth
              name="statemenT_DATE"
              id="statemenT_DATE"
              label={t("date")}
              onChange={(e) => handleInformation(e, 1)}
            />
          </Column>
          <Column>
            <CssTextField
              value={vendorInformation.statemenT_NAME}
              type="text"
              required
              fullWidth
              label={t("fullName")}
              name="statemenT_NAME"
              id="statemenT_NAME"
              onChange={(e) => handleInformation(e)}
            />
          </Column>
          <Column>
            <CssTextField
              value={vendorInformation.statemenT_POSITION_COMPANY}
              type="text"
              required
              fullWidth
              label={t("positionCompany")}
              name="statemenT_POSITION_COMPANY"
              id="statemenT_POSITION_COMPANY"
              onChange={(e) => handleInformation(e)}
            />
          </Column>
        </Container>
        <Container>
          <ColumnButtons>
            <Button onClick={handleBack}>{t("back")}</Button>
          </ColumnButtons>
          <ColumnButtons>
            <Button>{t("finish")}</Button>
          </ColumnButtons>
        </Container>
      </form>
    </>
  );
};

export default Step5;
